import React, {useState} from 'react';
import Radium from 'radium';
import {Container} from 'flux/utils';

import DesignerStore from 'stores/DesignerStore';
import SessionStore from 'stores/SessionStore';

import HttpService from 'service/HttpService';
import Dispatcher from 'service/Dispatcher';

import AppUtil from 'AppUtil';
import {Button} from 'views/AppElements';

import ReactTable from 'react-table';

import {A} from 'views/AppElements';

import OrdersList from 'views/order/OrdersList';

import AppConstants from 'AppConstants';
import PaymentModal from '../views/designer/PaymentModal';


const WithdrawStat = Radium((props) => {

	const redeemRequested = props.redeemRequested;
	const redeemed = props.redeemed;
	const hasRedeemRequest = redeemRequested !== null && redeemRequested > 0;
	const hasRedeemedBefore = redeemed !== null && redeemed > 0;

	if(!hasRedeemRequest && !hasRedeemedBefore)
		return null;

	return <span style={{fontSize: '160%', display: 'block', textAlign: 'right', color: '#807979', background: 'white', padding: '5px'}}>
				{
					hasRedeemRequest &&
					<span><b>Withdrawal Requested: </b>Rs. {AppUtil.formatNumber(redeemRequested)} </span>
				}
				
				{
					hasRedeemedBefore &&
					<span style={{marginLeft: '15px'}}><b>Withdrawn: </b>Rs. {AppUtil.formatNumber(redeemed)}</span>
				}


				<Button style={{marginLeft: '15px'}} mui="true" href="/withdrawals"><i className="fa fa-history" aria-hidden="true"></i> View History</Button>
				
		</span>
});




const Balance = (props) => {
	const currentBalance = props.currentBalance;
	const lockedBalance = props.lockedBalance;
	const productStats = props.productStats;
	const [openPaymentModal, setOpenPaymentModel] = useState(false);

	return <div style={props.style}>
			
			<br />

			<span style={{color: 'gray'}}>Your Current Balance</span>
			<br />
			<span>Rs. {AppUtil.formatNumber(currentBalance)}</span>

			{(currentBalance > 0) &&
				<span>
					<br />
					
					{
						openPaymentModal &&
						<PaymentModal productStats={productStats} currentBalance={currentBalance} 
							open={openPaymentModal} 
							onClose={() => {
								setOpenPaymentModel(false);
							}} />
					}
					<Button mui="true" variant="primary" color="raised" 
							onClick={() => setOpenPaymentModel(true)}
							>Withdraw</Button>	
				</span>
			}
			

			<hr />
			<span style={{color: 'gray'}}><i className="fa fa-lock" aria-hidden="true"></i> Locked Balance</span>
			<br />
			<span>Rs. {AppUtil.formatNumber(lockedBalance)}</span>
		</div>
};


const SalesTargetList = Radium((props) => {
	
	const completedProductStats = props.completedProductStats;

	const productCol = {Header: 'Product', accessor: 'currentTarget.product', Cell: props => {
							const product = props.value;
							const detailUrl = AppUtil.getProductURL(product);

							return <A href={detailUrl}>{AppUtil.getProductTitle(product)}</A>;
						}};

	const targetColumns = [{Header: 'Quantity Sold', accessor: 'targetAchieved', 
						Cell: props => AppUtil.formatNumber(props.value)},
					{Header: 'Commission', accessor: 'currentTarget', 
						Cell: props => {
							const commissionAmount = props.value.commissionPct * props.value.product.margin/100.0;
							return "Rs. "+AppUtil.formatNumber(commissionAmount);

					}},
					{Header: 'Amount Earned', accessor: 'amountEarned', Cell: props => {
						const productStat = props.original;

						const amount = "Rs. "+AppUtil.formatNumber(props.value);

						if(productStat.targetAchieved < productStat.currentTarget.salesTarget)
							return <span style={{color: 'gray'}}><i className="fa fa-lock" aria-hidden="true"></i> {amount}</span>;
						else
							return amount;
						
					}}];

	const columns = [productCol].concat(targetColumns);

	const showLoading = completedProductStats? false: true;
	
	const style = [];

	if(props.style)
		style.push(props.style);

	return <div style={style}>
		<h2>Your Earnings Info <i className="fa fa-money" aria-hidden="true"></i></h2>
		
		<ReactTable data={completedProductStats? completedProductStats: []} columns={columns} minRows={5} 
					noDataText="You have not made any sales." loading={showLoading} />
	</div>
});



class DesignerDashboardContainer extends React.Component {

	static getStores() {
		return [DesignerStore, SessionStore];
	}

	static calculateState(prevState) {
		return {
			balance: DesignerStore.getDesignerBalance(),
			session: SessionStore.getCurrentSession(),
			allPendingOrders:  DesignerStore.getAllPendingOrders()
		}
	}

	componentDidMount() {
		if(this.state.session === null) {
			Dispatcher.dispatchAlertWithAction(AppConstants.LOGIN_TO_CONTINUE_MSG, "WARN");
			return;
		}

		this.loadDashboardData();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevState.session === null && this.state.session !== null) {
			this.loadDashboardData();
		}

	}

	loadDashboardData() {
		const userId = this.props.userId;
		
		if(this.state.balance === null)
			HttpService.getDesignerBalance(userId);

		if(this.state.allPendingOrders === null)
			HttpService.getDesignerPendingOrders(userId);
	}

	render() {
		if(this.state.session === null)
			return null;

		const currentBalance = this.state.balance? this.state.balance.unlockedBalance: 0;
		const lockedBalance = this.state.balance? this.state.balance.lockedBalance: 0;

		const redeemRequested = this.state.balance? this.state.balance.redeemRequestedAmount: null;
		const redeemed = this.state.balance? this.state.balance.redeemedAmount: null;

		
		return <div style={{margin: '0', padding: '10px 0'}}>
					<WithdrawStat redeemRequested={redeemRequested} redeemed={redeemed} />
					
					<div className='mainContainer'>
						<div className='flexRow'>
							<Balance currentBalance={currentBalance} 
									lockedBalance={lockedBalance} 
									productStats={this.state.balance? this.state.balance.productStats: []}
									style={{flexGrow: '1', padding: '10px', textAlign: 'center', fontSize: '200%', alignSelf: 'center'}} />

							
							<SalesTargetList style={{flexGrow: "3", '@media (max-width: 770px)': {flexGrow: '1', width: '100%'}}} 
										completedProductStats={this.state.balance? this.state.balance.productStats: null} />
						</div>

						<hr />

						<OrdersList orders={this.state.allPendingOrders} 
										title="Your Pending Orders" showPaymentOption={false} showProductInfo={true} />
					</div>					
		</div>
	}
}

export default Radium(Container.create(DesignerDashboardContainer));




// WEBPACK FOOTER //
// ./src/containers/DesignerDashboardContainer.js